export default __webpack_public_path__ + "static/media/workspaceCloud.556cd723.png";